import { Box, Typography } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { useNavigate } from "react-router-dom";
import { IStore } from "../../../services/api/Store/types";
import { PrimaryButton } from "../buttons/PrimaryButton";
import { sharedStyles } from "@/styles/shared";
import defaultStoreImage from "@/assets/svg/defaultStore.svg";

interface MapHoverCardProps {
  imageUrl: string;
  primaryText: string;
  secondaryText: string;
  selectedStore?: IStore;
}

export const MapCard = (props: MapHoverCardProps) => {
  const { imageUrl, primaryText, secondaryText, selectedStore } = props;

  const navigate = useNavigate();

  const handleSelectStoreClick = (storeId: string) =>
    navigate(`/store?id=${storeId}`);

  return (
    <Box sx={sharedStyles.verticalContent}>
      <img
        src={imageUrl || defaultStoreImage}
        alt={`${primaryText} preview`}
        style={{
          objectFit: "cover",
          width: "100%",
          maxHeight: "150px",
          height: "100%",
        }}
      />

      <Typography variant="h6" fontWeight="bold" textAlign="center">
        {primaryText}
      </Typography>

      <Typography variant="body2" textAlign="justify">
        <LocationOnIcon sx={{ width: 13, height: 13 }} /> {secondaryText}
      </Typography>

      <PrimaryButton
        label="Ir para a página da loja"
        onClickAction={() => handleSelectStoreClick(selectedStore.id)}
        styles={sharedStyles.secondaryColor}
      />
    </Box>
  );
};

